import React from "react";
import {useTranslation} from "react-i18next";
import {ProductElementModifier} from "../../providers/product/product-types";

export interface ConfiguratorModifierStateProps {
    onConfirm: (modifier: ProductElementModifier) => void;
    onCancel: () => void;
    modifiers: ProductElementModifier[];
}

export const ConfiguratorModifierState = ({onConfirm, onCancel, modifiers}: ConfiguratorModifierStateProps) => {
    const {t} = useTranslation();
    return (
        <div className="mt-8 mb-8 rounded-lg border-2 p-4 border-dashed border-gray-300 hover:border-gray-400">
            <div>
                <div className="mt-3 text-center sm:mt-5">
                    <h3 className="text-base font-semibold text-gray-900">
                        {t('CONFIG.MODIFIER_TITLE')}
                    </h3>
                    <div className="mt-2">
                        <p className="text-sm text-gray-500">
                            {t('CONFIG.MODIFIER_DESCRIPTION')}
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-3 sm:gap-3">
                {modifiers.map((modifier, index) => (
                    <button
                        key={index}
                        type="button"
                        onClick={() => onConfirm(modifier)}
                        className="inline-flex w-full justify-center rounded-md bg-yellow-300 px-3 py-2 text-sm font-semibold transition duration-150 text-gray-700 shadow-sm hover:bg-yellow-400 col-span-3"
                    >
                        {t('CONFIG.MODIFIER_' + modifier.name)}
                    </button>
                ))}

                <button
                    type="button"
                    data-autofocus
                    onClick={() => onCancel()}
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 col-span-3"
                >
                    {t('BUTTON.CANCEL')}
                </button>
            </div>
        </div>
    )
}